<template>
<el-dialog title="新增" :close-on-click-modal="false" width="40%" :visible.sync="viewData.visible">
    <el-form :model="dataForm" ref="dataForm" @keyup.enter.native="dataFormSubmit()" size="small" label-width="0px" class="org-dialog-form">
        <div class="des_box">
            <el-descriptions class="margin-top" :column="1" size="small" border style="margin-bottom: 15px;">
                <el-descriptions-item label="器具类型名称:" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item style="margin-bottom: 0;" prop="name" :rules="[{ required: true, message: '请输入器具类型名称', trigger: 'blur' }]">
                        <el-input v-model="dataForm.name" placeholder="器具类型名称" size="small"></el-input>
                    </el-form-item>
                </el-descriptions-item>
            </el-descriptions>
        </div>
        <el-row :gutter="40">
            <el-col :span="24" style="text-align:right;">
                <el-button size="small" @click="viewData.visible = false">
                    取消
                </el-button>
                <el-button size="small" type="primary" @click="dataFormSubmit()">
                    保存
                </el-button>
            </el-col>
        </el-row>
    </el-form>
</el-dialog>
</template>

<script>
import {
    createApplianceType
} from '@/controller/systemData'
export default {
    data() {
        return {
            viewData: {
                visible: false,
                width: ''
            },
            dataForm: {
                name: '',
            },
        }
    },
    methods: {
        init() {
            this.viewData.visible = true
            this.$nextTick(() => {
                this.$refs['dataForm'].resetFields()
            })
        },
        // 表单提交
        dataFormSubmit() {
            this.$refs['dataForm'].validate((valid) => {
                if (valid) {
                    let params = {
                        'name': this.dataForm.name,
                    }
                    createApplianceType(params).then(data => {
                        if (data && data.code === '00') {
                            this.$message({
                                message: '操作成功',
                                type: 'success',
                                onClose: () => {
                                    this.viewData.visible = false
                                    this.$emit('refreshDataList')
                                }
                            })
                        } else {
                            this.$message.error(data.msg)
                        }
                    })
                }
            })
        },
        getStyle() {
            return 'width: 130px; text-align: right'
        },
        getStyle2() {
            return 'width: 455.5px;'
        }
    }
}
</script>
